import { render, staticRenderFns } from "./CurvesWrapper.vue?vue&type=template&id=776bc6a4&"
import script from "./CurvesWrapper.vue?vue&type=script&lang=ts&"
export * from "./CurvesWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports